// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  slug: __t.string(),
  name: __t.string(),
  description: __t.string(),
  tier: __t.string(),
  discountPercent: __t.u32().name("discount_percent"),
  priceCoins: __t.i64().name("price_coins"),
  isAvailable: __t.bool().name("is_available"),
  isSeasonal: __t.bool().name("is_seasonal"),
  previewAsset: __t.string().name("preview_asset"),
  createdAt: __t.u64().name("created_at"),
});
